define('services/ajax-config',['bootbox', 'services/i18n', 'services/session', 'services/platform.service', 'debug'], function(Bootbox, i18n, Session, PlatformService, DEBUG) {

    var AjaxConfig = {
        setBeforeSendAjaxConfig: function() {
            $(document).ajaxSend( function(event, xhr) {
                if (DEBUG) xhr.setRequestHeader("X-Debug", true);
                if (Session.getToken()) {
                    xhr.setRequestHeader('Authorization', "Bearer " + Session.getToken());
                }
                xhr.setRequestHeader('Accept', 'application/json; version=' + env.APP_VERSION);
            });

            return this;
        },

        setAjaxErrorConfig: function() {
            var self = this;
            $(document).ajaxError(function (e, xhr) {
                if (xhr.status === 406) {
                    self.showUpdateModal();
                }
            });

            return this;
        },

        showUpdateModal: function() {
            var self = this;
            if (!Session.isBootboxDisplayed()) {
                Session.setBootboxDisplayedStatus(true);
                if (PlatformService.isNative()) {
                    // Get platform info to determine which store to open
                    PlatformService.getPlatform().then(function(platform) {
                        Bootbox.alert({
                            message: i18n.t("messages:current-version-is-no-longer-supported"),
                            closeButton: false,
                            callback: function() {
                                if (platform === "android") {
                                    window.open(encodeURI('https://play.google.com/store/apps/details?id=com.totalcoaching.myonlinecoach'));
                                } else if (platform === "ios") {
                                    window.open(encodeURI('https://itunes.apple.com/ca/app/my-online-coach/id1282436695'));
                                }
                                Session.onUnauthorized();
                                Session.setBootboxDisplayedStatus(false);
                            }
                        });
                    }).catch(function() {
                        // Fallback if platform detection fails
                        Bootbox.alert({
                            message: i18n.t("messages:current-version-is-no-longer-supported"),
                            closeButton: false,
                            callback: function() {
                                Session.onUnauthorized();
                                Session.setBootboxDisplayedStatus(false);
                            }
                        });
                    });
                } else {
                    Bootbox.alert({
                        message: i18n.t('messages:please-refresh-your-browser'),
                        closeButton: false,
                        callback: function() {
                            location.reload(true);
                            Session.onUnauthorized();
                            Session.setBootboxDisplayedStatus(false);
                        }
                    });
                }
            }
        }
    };

    return AjaxConfig;
});

